var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice"},[_vm._v(" **Solo se pueden seleccionar recibos de pago a partir de "+_vm._s(_vm.minDateReadable)+"** ")])
}
var staticRenderFns = []

export { render, staticRenderFns }